// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"62802622","8652":"92a78f46"}[chunkId] + ".chunk.css";
};